import produce from "immer";
import { Store } from "reducers/rootReducer";

type State = {
  ACTION_KEY?: string | null | undefined;
  ACTION_SELECTED_ID_KEY?: string | null | undefined;
  temporaryFilters?: boolean | null | undefined;
};

const initialState: State = {
  ACTION_KEY: null,
  ACTION_SELECTED_ID_KEY: null,
  temporaryFilters: null,
};

const SET_ACTION_KEY = "app/redirect/SET_ACTION_KEY";
const SET_ACTION_ID = "app/redirect/SET_ACTION_ID";
const SET_TEMPORARY_FILTERS = "app/redirect/SET_TEMPORARY_FILTERS";

type Action =
  | {
      type: typeof SET_ACTION_KEY;
      payload: string | null | undefined;
    }
  | {
      type: typeof SET_ACTION_ID;
      payload: string | null | undefined;
    }
  | {
      type: typeof SET_TEMPORARY_FILTERS;
      payload: boolean | null | undefined;
    };

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case SET_ACTION_KEY:
        draft.ACTION_KEY = action.payload;
        break;
      case SET_ACTION_ID:
        draft.ACTION_SELECTED_ID_KEY = action.payload;
        break;
      case SET_TEMPORARY_FILTERS:
        draft.temporaryFilters = action.payload;
        break;
      default:
        return state;
    }
  });
}

export const setActionKey = (payload: string | null | undefined): Action => ({
  type: SET_ACTION_KEY,
  payload: payload,
});
export const setActionID = (payload: string | null | undefined): Action => ({
  type: SET_ACTION_ID,
  payload: payload,
});

export const setTemporaryFilters = (payload: boolean | undefined): Action => ({
  type: SET_TEMPORARY_FILTERS,
  payload: payload,
});

export const selectActionKey = (app: Store) => app.redirect.ACTION_KEY;
export const selectActionID = (app: Store) =>
  app.redirect.ACTION_SELECTED_ID_KEY;
export const selectTemporaryFilters = (app: Store) =>
  app.redirect.temporaryFilters;
